import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
export function mergeDeepWithLocalStorage(payload) {
  return {
    type: ActionTypes.LOCAL_STORAGE_MERGE_DEEP,
    payload
  };
}